module.exports = __webpack_public_path__ + "img/evaluate_03.8569762c.png";